module.exports = __webpack_public_path__ + "static/media/DSC03140.e68d3b3e.jpg";